import {DefaultPageProps} from "@models/DefaultProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {ISolicitacao} from "@models/solicitacoes/solicitacoes.ts";
import {useEffect, useState} from "react";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {ILog} from "@models/seguranca/ILog.ts";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {LogInformationRow} from "@components/seguranca/LogInformation.tsx";
import {useSolicitacao} from "@components/solicitacoes/hooks/useSolicitacao.tsx";

interface SolicitacaoLogsPageProps extends DefaultPageProps {
    solicitacao: number | ISolicitacao
}

export function SolicitacaoLogsPage(props: SolicitacaoLogsPageProps) {
    const {getLogsSolicitacao} = useSolicitacao()
    const [value, setValue] = useState<ISolicitacao | undefined>()
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});
    const [logs, setLogs] = useState<ILog[]>([]);

    useEffect(() => {
        if (typeof props.solicitacao == 'object') {
            setValue(props.solicitacao);
        } else {
            // TODO: buscar solicitacao pelo ID
            setValue(undefined);
        }

    }, [props.solicitacao]);

    useEffect(() => {
        if (value == null) return;

        if (pagination.page <= 0) {
            setPagination(prev => ({...prev, page: 1}))
            return
        }

        setPagination(prev => ({...prev, loading: true}));
        getLogsSolicitacao({data: {idSolicitacao: value.id}, pagination: pagination}).then(x => {
            if (x.hasData) {
                setLogs(x.items);
                setPagination(prev => ({...prev, ...x.pagination, page: pagination.page}))
            }
        }).finally(() => {
            setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
        })


    }, [pagination.page, pagination.ignoreCache == true, value]);


    return (<DefaultContainer titulo={"Logs da solicitacao"}
                              permissaoNecessaria={'VisualizarLogs'}
                              pageProps={{pagination, setPagination}}>
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Usuario</TableCell>
                        <TableCell>Data/Hora</TableCell>
                        <TableCell>Detalhes</TableCell>
                        <TableCell>Json</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {logs.map(x => <LogInformationRow value={x}/>)}
                </TableBody>
            </Table>
        </TableContainer>
    </DefaultContainer>)
}